import React from "react";
import {
  TableCell,
  TableHead,
  TableRow,
  TableSortLabel,
  Tooltip,
  Typography,
  useTheme,
} from "@mui/material";
import { v2LabelSx } from "../../PerformanceDashboardV2/v2Theme";
import { getHeadCellSx } from "./positionTableV2Styles";

const HeadCell = ({ column, order, orderBy, onRequestSort, sticky }) => {
  const theme = useTheme();
  const active = orderBy === column.id;
  const align = column.alignLeft ? "left" : "right";

  return (
    <TableCell
      align={align}
      sortDirection={active ? order : false}
      sx={getHeadCellSx(theme, { sticky, active })}
    >
      <Tooltip title={column.title || column.label} arrow placement="top">
        <TableSortLabel
          active={active}
          direction={active ? order : "desc"}
          hideSortIcon
          onClick={(event) => {
            event.stopPropagation();
            onRequestSort?.(event, column.id);
          }}
          sx={{
            ...v2LabelSx(theme),
            fontWeight: active ? 800 : 600,
            letterSpacing: "0.04em",
            fontSize: "0.78rem",
            cursor: "pointer",
            color: active
              ? theme.palette.mode === "dark"
                ? "#FFFFFF"
                : theme.palette.text.primary
              : "inherit",
            "&:hover": {
              color:
                theme.palette.mode === "dark"
                  ? "#FFFFFF"
                  : theme.palette.text.primary,
            },
            "&.Mui-active": {
              color:
                theme.palette.mode === "dark"
                  ? "#FFFFFF"
                  : theme.palette.text.primary,
            },
            "& .MuiTableSortLabel-icon": {
              display: "none",
            },
          }}
        >
          {column.label}
        </TableSortLabel>
      </Tooltip>
    </TableCell>
  );
};

const PositionTableHeadV2 = ({ columns, order, orderBy, onRequestSort, tickerColumnId }) => {
  return (
    <TableHead>
      <TableRow>
        {columns.map((column) => (
          <HeadCell
            key={column.id}
            column={column}
            order={order}
            orderBy={orderBy}
            onRequestSort={onRequestSort}
            sticky={column.id === tickerColumnId}
          />
        ))}
      </TableRow>
    </TableHead>
  );
};

export default PositionTableHeadV2;
